module.exports = __webpack_public_path__ + "img/gzgzcsjbqjd.80a102e4.png";